export default __webpack_public_path__ + "static/media/icon-chevron.d5499e5a.svg";